/* Čapkov redesign: sekce „Načíst až při scrollu“ (featured-collection s rd_lazy).
   Stránka dostane jen kostru [data-rdlz] pevné výšky; až se kostra přiblíží k oknu, stáhne se JEDNÍM dotazem stejná adresa s ?view=rdlazy
   (templates/*.rdlazy.json s "layout": false = jen tyto sekce) a kostry se vymění za hotové sekce. Bez IntersectionObserveru se načte hned. */
(function () {
  'use strict';
  if (window.__rdLazy) return; window.__rdLazy = 1;
  var P = null;
  function key(id) { return String(id || '').replace(/^.*__/, ''); }
  function runScripts(root) {
    root.querySelectorAll('script:not([src])').forEach(function (o) {
      if (o.type && o.type !== 'text/javascript' && o.type !== 'module') return;
      var n = document.createElement('script'); if (o.type) n.type = o.type; n.textContent = o.textContent;
      o.parentNode.replaceChild(n, o);
    });
  }
  function load() {
    if (P) return P;
    P = fetch(location.pathname + '?view=rdlazy', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), src = {};
        d.querySelectorAll('.shopify-section').forEach(function (x) { src[key(x.id)] = x; });
        document.querySelectorAll('[data-rdlz]').forEach(function (sh) {
          var host = sh.closest('.shopify-section'), s = src[sh.getAttribute('data-rdlz')];
          if (!host || !s) { sh.style.minHeight = '0'; return; }
          var n = document.importNode(s, true); host.replaceWith(n); runScripts(n);
        });
        document.dispatchEvent(new CustomEvent('rd:lazy-loaded'));
      })
      .catch(function () { P = null; document.querySelectorAll('[data-rdlz]').forEach(function (sh) { sh.style.minHeight = '0'; }); });
    return P;
  }
  function init() {
    var shells = document.querySelectorAll('[data-rdlz]'); if (!shells.length) return;
    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
    shells.forEach(function (s) { io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
